export default "__VITE_ASSET__4z9ROxT3__"